import { Card, CardContent, Divider, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import DrawerModal from "./drawerModal";
import { formatActivityTimestamp } from "../../utils/formatter.js";
import { ACTIVITY_TYPES, TRANSACTION_CATEGORIES, TRANSACTION_TYPES } from "../../utils/types";
import CircularLoader from "../loading/circularLoader";
import GenericError from "../error/genericError";
import { useEffect, useState } from "react";
import { useDataProvider } from "react-admin";
import ActionButton from "../button/actionButton";
import ModalConsumer from "../consumer/modalConsumer";
import CompleteTransactionDialog from "../dialog/completeTransactionDialog";
import {OpsRole, AdminOrExternalOpsRole} from "../../utils/role";
import { useHistory } from "react-router-dom";
import ConfirmTransactionDialog from "../dialog/confirmTransactionDialog";
import RetryIcon from "../icons/retryIcon";
import CompleteOtcSendDialog from "../dialog/completeOtcSendDialog";
import CompleteOtcDepositDialog from "../dialog/completeOtcDepositDialog";
import { client } from "../../utils/data/graphql/client";
import { cancelOtcOrderMutation, completeOtcOrderMutation } from "../../utils/data/graphql/otc/mutations";
import { getOtcOrderQuery } from "../../utils/data/graphql/otc/queries";
import RefundCancelTransactionDialog from "../dialog/refundCancelTransactionDialog";
import { useAuth0 } from "@auth0/auth0-react";

const ViewActivityDrawer = ({
                                params: {row},
                                customerId,
                                activityReference,
                                refreshActivityList,
                                onRefreshCustomer,
                                onClose,
                                resource = "activities"
                            }) => {
    const {
        id,
        userId,
        type,
        reference,
        linkedTransaction
    } = row;
    let content = <UnknownActivityDetails data={row}/>
    const [customer, setCustomer] = useState()
    const [refresh, setRefresh] = useState(false)
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState();
    const [reloadTick, setReloadTick] = useState(0);
    const reloadDrawer = () => setReloadTick(t => t + 1);
    const dataProvider = useDataProvider();
    const showCustomerCard = window.location.href.includes("/#/globalActivities")
    useEffect(() => {
        showCustomerCard && setRefresh(true)
    }, [showCustomerCard])
    useEffect(() => {
        if (refresh === true && showCustomerCard) {
            setLoading(true)
            dataProvider.getOne('customers', {id: userId})
                .then(({data}) => {
                    setCustomer(data);
                })
                .catch((error) => {
                    setError(error)
                })
                .finally(() => {
                    setLoading(false)
                    setRefresh(false)
                });
        }
    }, [refresh, showCustomerCard])
    switch (type) {
        case ACTIVITY_TYPES.OTC_ORDER:
            // Determine if OTC order is deposit or send based on heading or subHeading
            const heading = row?.feedInfo?.heading?.toLowerCase() || '';
            const subHeading = row?.feedInfo?.subHeading?.toLowerCase() || '';
            const isOtcDeposit = heading.includes('top up') || subHeading.includes('deposit');
            
            if (isOtcDeposit) {
                content = <DepositActivityDetails key={reloadTick} activityId={id} customerId={customerId} type={ACTIVITY_TYPES.OTC_ORDER}
                                                  linkedTransaction={linkedTransaction}
                                                  resource={resource}
                                                  activityReference={activityReference || reference}
                                                  orderId={reference}
                                                  isLoading={loading}
                                                  parentError={error}
                                                  customer={customer}
                                                  onClose={onClose}
                                                  refreshActivityList={refreshActivityList}
                                                  onRefreshCustomer={onRefreshCustomer}
                                                  onReload={reloadDrawer}
                                                  isOtcDeposit={true}/>
            } else {
                content = <SentActivityDetails key={reloadTick} activityId={id} customerId={customerId} type={ACTIVITY_TYPES.OTC_ORDER}
                                               linkedTransaction={linkedTransaction}
                                               resource={resource}
                                               isLoading={loading}
                                               activityReference={activityReference || reference}
                                               parentError={error}
                                               customer={customer}
                                               onClose={onClose}
                                               refreshActivityList={refreshActivityList}
                                               onRefreshCustomer={onRefreshCustomer}
                                               onReload={reloadDrawer}
                                               isOtcDeposit={false}/>
            }
            break
        case ACTIVITY_TYPES.DEPOSIT:
            content = <DepositActivityDetails key={reloadTick} activityId={id} customerId={customerId} type={type}
                                              linkedTransaction={linkedTransaction}
                                              resource={resource}
                                              activityReference={activityReference}
                                              orderId={reference}
                                              isLoading={loading}
                                              parentError={error}
                                              customer={customer}
                                              onClose={onClose}
                                              refreshActivityList={refreshActivityList}
                                              onRefreshCustomer={onRefreshCustomer}
                                              onReload={reloadDrawer}/>
            break
        case ACTIVITY_TYPES.WITHDRAWAL:
            content = <WithdrawActivityDetails key={reloadTick} activityId={id} customerId={customerId} type={type}
                                               linkedTransaction={linkedTransaction}
                                               resource={resource}
                                               activityReference={activityReference}
                                               orderId={reference}
                                               isLoading={loading}
                                               parentError={error}
                                               customer={customer}
                                               onClose={onClose}
                                               refreshActivityList={refreshActivityList}
                                               onRefreshCustomer={onRefreshCustomer}
                                               onReload={reloadDrawer}/>
            break
        case ACTIVITY_TYPES.PAYMENT:
            content = <PaymentActivityDetails key={reloadTick} activityId={id} customerId={customerId} type={type}
                                              resource={resource}
                                              activityReference={activityReference}
                                              orderId={reference}
                                              isLoading={loading}
                                              parentError={error}
                                              customer={customer}
                                              onClose={onClose}
                                              linkedTransaction={linkedTransaction}/>
            break
        case ACTIVITY_TYPES.REFUND:
            content = <RefundActivityDetails key={reloadTick} activityId={id} customerId={customerId} type={type}
                                             resource={resource}
                                             activityReference={activityReference}
                                             orderId={reference}
                                             isLoading={loading}
                                             parentError={error}
                                             customer={customer}
                                             onClose={onClose}
                                             linkedTransaction={linkedTransaction}/>
            break
        case ACTIVITY_TYPES.SENT:
            content = <SentActivityDetails key={reloadTick} activityId={id} customerId={customerId} type={type}
                                           linkedTransaction={linkedTransaction}
                                           resource={resource}
                                           isLoading={loading}
                                           activityReference={activityReference}
                                           parentError={error}
                                           customer={customer}
                                           onClose={onClose}
                                           refreshActivityList={refreshActivityList}
                                           onRefreshCustomer={onRefreshCustomer}
                                           onReload={reloadDrawer}/>
            break
        case ACTIVITY_TYPES.RECEIVED:
            content = <SendReceivedActivityDetails key={reloadTick} activityId={id} customerId={customerId} type={type}
                                                   resource={resource}
                                                   isLoading={loading}
                                                   parentError={error}
                                                   customer={customer}
                                                   activityReference={activityReference}
                                                   onClose={onClose}
                                                   linkedTransaction={linkedTransaction}/>
            break
        default:
            content = <UnknownActivityDetails data={row}/>
    }
    return (
        <DrawerModal onClose={onClose}>
            {content}
        </DrawerModal>
    )
}

const useDetailStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100%',
    },
    category: {
        marginBottom: '16px'
    },
    heading: {
        marginBottom: '16px'
    },
    status: {
        margin: 0,
        color: theme.text.primary,
        fontFamily: 'DM Sans',
        fontStyle: 'normal',
        fontWeight: '500',
        fontSize: '16px',
        lineHeight: '21px',
    },
    errorContainer: {
        width: '100%',
        height: '100%',
        // minHeight: `${cardHeight}em`,
        display: 'flex',
    },
    error: {
        display: 'flex',
        margin: 'auto'
    },
    infoCard: {
        margin: '16px 0px 16px 0px',
        '&:first-child': {
            marginTop: '49px',
        },
        '& > div': {
            '& > div': {
                paddingTop: '16px',
                paddingBottom: '16px'
            },
            '& > hr': {
                marginTop: '16px',
                marginBottom: '16px'
            }
        }
    },
    infoRow: {
        display: 'flex',
        justifyContent: 'space-between',
        padding: '12px 0px 0px 12px',
    },
    statusRow: {
        display: 'flex',
        padding: '12px 0px 0px 12px',
    },
    buttonRow: {
        paddingTop: '8px',
        display: 'flex',
        justifyContent: 'center',
    },
    buttonContainer: {
        display: 'flex',
        justifyContent: 'center',
        marginTop: '32px',
    },
    loader: {
        marginLeft: '-24px',
    },
    resultContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignContent: 'center',
        height: '100%',
    },
    name: {
        fontFamily: 'DM Sans',
        fontStyle: 'normal',
        fontWeight: 400,
        fontSize: '16px',
        lineHeight: '21px',
        textAlign: 'left',
        color: '#FFFFFF',
        opacity: 0.5
    },
    retry: {
        fontFamily: 'SF Pro Text',
        fontStyle: 'normal',
        fontSize: '16px',
        fontWeight: '400',
        lineHeight: '21px',
        textAlign: 'left',
        color: '#A3A2FF',
    },
    value: {
        fontFamily: 'DM Sans',
        fontStyle: 'normal',
        fontWeight: 400,
        fontSize: '16px',
        lineHeight: '21px',
        textAlign: 'right',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        maxWidth: '75%',
        color: '#FFFFFF'
    },
    linkValue: {
        textDecorationLine: 'underline',
        color: '#A3A2FF',
        cursor: 'pointer'
    },
    divider: {
        width: '100%',
        marginLeft: '16px',
    },
}));

const UnknownActivityDetails = ({
                                    data: {
                                        userId,
                                        timestamp,
                                        reference,
                                        feedInfo: {
                                            heading,
                                            subHeading
                                        }
                                    }
                                }) => {
    const classes = useDetailStyles();
    return (
        <div>
            <Typography variant='h2' className={classes.heading}>
                {subHeading}
            </Typography>
            <Typography variant='h1' className={classes.heading}>
                {heading}
            </Typography>
            <p className={classes.status}>
                {`${formatActivityTimestamp(timestamp)} • ${subHeading}`}
            </p>
            <Card className={classes.infoCard}>
                <CardContent className={classes.infoContent}>
                    <div className={classes.infoRow}>
                        <Typography variant="body1" className={classes.name}>Customer ID</Typography>
                        <Typography variant="body1" className={classes.value}>{userId}</Typography>
                    </div>
                </CardContent>
            </Card>
            <Card className={classes.infoCard}>
                <CardContent className={classes.infoContent}>
                    {
                        reference &&
                        <div className={classes.infoRow}>
                            <Typography variant="body1" className={classes.name}>Reference</Typography>
                            <Typography variant="body1" className={classes.value}>{reference}</Typography>
                        </div>
                    }
                </CardContent>
            </Card>
        </div>
    )
}

const DepositActivityDetails = ({
                                    customerId,
                                    activityId,
                                    type,
                                    linkedTransaction,
                                    refreshActivityList,
                                    onRefreshCustomer,
                                    onReload,
                                    resource,
                                    isLoading,
                                    parentError,
                                    customer,
                                    onClose,
                                    orderId,
                                    activityReference,
                                    isOtcDeposit
                                }) => {
    const history = useHistory();
    const { user } = useAuth0();
    const [data, setData] = useState({})
    const [otcOrder, setOtcOrder] = useState(null)
    const [refresh, setRefresh] = useState(false)
    const [loading, setLoading] = useState(isLoading);
    const [error, setError] = useState(parentError);
    const dataProvider = useDataProvider();
    useEffect(() => {
        setRefresh(true)
    }, [])
    useEffect(() => {
        if (refresh === true) {
            setLoading(true)
            // For onchain activities, use activityId. For OTC orders, activityReference contains the OTC order ID.
            const fetchId = activityId || activityReference;
            dataProvider.getOne(resource, {customerId, activityId: fetchId, type, orderId, activityReference, isOtcDeposit})
                .then(({data}) => {
                    setData(data);
                })
                .catch((error) => {
                    setError(error)
                })
                .finally(() => {
                    setLoading(false)
                    setRefresh(false)
                });
        }
    }, [refresh])
    
    // Fetch OTC order for settlement details
    useEffect(() => {
        const isOtcOrderType = type === ACTIVITY_TYPES.OTC_ORDER;
        if (isOtcOrderType && activityReference) {
            client.query({
                query: getOtcOrderQuery,
                variables: { id: activityReference },
                fetchPolicy: 'network-only'
            })
            .then(({ data }) => {
                if (data?.otcOrder_Admin) {
                    setOtcOrder(data.otcOrder_Admin);
                }
            })
            .catch((err) => {
                console.error('Failed to fetch OTC order details:', err);
            });
        }
    }, [type, activityReference]);
    const {
        categoryName,
        heading,
        status,
        transactionDate,
        reference,
        transferMethodName,
        transferMethodValue,
        exchangeRateName,
        exchangeRateValue,
        blockchainNetwork,
        blockchainScanLink
    } = data
    const resolvedLinkedTransaction = linkedTransaction ?? data["linkedTransaction"] ?? {}
    const {
        accountId,
        amount: linkedAmount,
        currency: linkedCurrency,
        orderId: linkedOrderId,
        type: transactionType,
        category: transactionCategory,
    } = resolvedLinkedTransaction
    const classes = useDetailStyles();
    const isBank = transferMethodName === "From bank account"
    const isPayId = transferMethodName === "From PayID"
    const isFiat = isBank || isPayId
    // Treat as OTC only if heading contains "(OTC)" marker from BFF
    const isOtcDetail = heading?.toLowerCase()?.includes('(otc)');
    // Metadata is now in the activity data itself
    const metadata = data?.metadata;
    const shouldShowMetadata = metadata && (metadata.createdByEmail || metadata.completedByEmail || metadata.completedAt || metadata.cancelledByEmail || metadata.cancelledAt);
    
    // Extract settlement details from OTC order
    const settlementDetails = otcOrder?.settlementDetails || {};
    const isCompleted = status === "Completed";
    
    return (
        <div className={classes.root}>
            {(error || (!data && !loading)) ?
                <div className={classes.errorContainer}>
                    <GenericError onClick={() => setRefresh(true)} className={classes.error}/>
                </div>
                : loading ?
                    <div className={classes.resultContainer}>
                        <CircularLoader className={classes.loader} trigger={loading} loaderSize='125px'/>
                    </div>
                    :
                    <>
                        <Typography variant='button' className={classes.category}>
                            {categoryName}
                        </Typography>
                        <Typography variant='h2' className={classes.heading}>
                            {heading}
                        </Typography>
                        {customer && <Card className={classes.infoCard}>
                            <CardContent className={classes.infoContent}>
                                <div className={classes.infoRow}>
                                    <Typography variant="body1" className={classes.name}>Customer</Typography>
                                    <Typography variant="body1"
                                                onClick={() => {
                                                    history.push(`/customers/${customer.id}/show`);
                                                    onClose();
                                                }}
                                                className={`${classes.value} ${classes.linkValue}`}>{customer.name}</Typography>
                                </div>
                                <div className={classes.infoRow}>
                                    <Typography variant="body1" className={classes.name}>Customer ID</Typography>
                                    <Typography variant="body1" className={classes.value}>{customer.id}</Typography>
                                </div>
                            </CardContent>
                        </Card>}
                        <Card className={classes.infoCard}>
                            <CardContent className={classes.infoContent}>
                                <div className={classes.infoRow}>
                                    <Typography variant="body1" className={classes.name}>Created At</Typography>
                                    <Typography variant="body1"
                                                className={classes.value}>{`${formatActivityTimestamp(transactionDate)}`}</Typography>
                                </div>
                                {
                                    transferMethodName && transferMethodValue &&
                                    <div className={classes.infoRow}>
                                        <Typography variant="body1"
                                                    className={classes.name}>{transferMethodName}</Typography>
                                        <Typography variant="body1"
                                                    className={classes.value}>{transferMethodValue}</Typography>
                                    </div>
                                }
                                {
                                    blockchainNetwork &&
                                    <div className={classes.infoRow}>
                                        <Typography variant="body1" className={classes.name}>Network</Typography>
                                        <Typography variant="body1"
                                                    className={classes.value}>{blockchainNetwork}</Typography>
                                    </div>
                                }
                                {
                                    reference && type !== ACTIVITY_TYPES.OTC_ORDER &&
                                    <div className={classes.infoRow}>
                                        <Typography variant="body1" className={classes.name}>Reference</Typography>
                                        <Typography variant="body1" className={classes.value}>{reference}</Typography>
                                    </div>
                                }
                                {
                                    activityReference &&
                                    <div className={classes.infoRow}>
                                        <Typography variant="body1" className={classes.name}>OrderID</Typography>
                                        <Typography variant="body1"
                                                    className={classes.value}>{activityReference}</Typography>
                                    </div>
                                }
                                <Divider
                                    className={classes.divider}
                                    orientation="horizontal"
                                    variant="fullWidth"
                                />
                                {/* Prefer explicit pay-in display over exchange rate row */}
                                {
                                    data?.payInDisplay &&
                                    <div className={classes.infoRow}>
                                        <Typography variant="body1" className={classes.name}>Pay-in</Typography>
                                        <Typography variant="body1" className={classes.value}>{data.payInDisplay}</Typography>
                                    </div>
                                }
                                {
                                    !data?.payInDisplay && exchangeRateName && exchangeRateValue &&
                                    <div className={classes.infoRow}>
                                        <Typography variant="body1"
                                                    className={classes.name}>{exchangeRateName}</Typography>
                                        <Typography variant="body1"
                                                    className={classes.value}>{exchangeRateValue}</Typography>
                                    </div>
                                }
                                <div className={classes.infoRow}>
                                    <Typography variant="body1" className={classes.name}>Status</Typography>
                                    <Typography variant="body1" className={classes.value}>{status}</Typography>
                                </div>
                                {blockchainScanLink && <div className={classes.buttonRow}>
                                    <ActionButton
                                        variant={'text'}
                                        onClick={() => window.open(blockchainScanLink, '_blank')}
                                    >
                                        View in explorer
                                    </ActionButton>
                                </div>}
                            </CardContent>
                        </Card>
                        {shouldShowMetadata && (
                            <Card className={classes.infoCard}>
                                <CardContent className={classes.infoContent}>
                                    {metadata.createdByEmail && (
                                        <div className={classes.infoRow}>
                                            <Typography variant="body1" className={classes.name}>Created By</Typography>
                                            <Typography variant="body1" className={classes.value}>{metadata.createdByEmail}</Typography>
                                        </div>
                                    )}
                                    {metadata.completedByEmail && (
                                        <div className={classes.infoRow}>
                                            <Typography variant="body1" className={classes.name}>Completed By</Typography>
                                            <Typography variant="body1" className={classes.value}>{metadata.completedByEmail}</Typography>
                                        </div>
                                    )}
                                    {metadata.completedAt && (
                                        <div className={classes.infoRow}>
                                            <Typography variant="body1" className={classes.name}>Completed At</Typography>
                                            <Typography variant="body1" className={classes.value}>{formatActivityTimestamp(new Date(metadata.completedAt))}</Typography>
                                        </div>
                                    )}
                                    {metadata.cancelledByEmail && (
                                        <div className={classes.infoRow}>
                                            <Typography variant="body1" className={classes.name}>Cancelled By</Typography>
                                            <Typography variant="body1" className={classes.value}>{metadata.cancelledByEmail}</Typography>
                                        </div>
                                    )}
                                    {metadata.cancelledAt && (
                                        <div className={classes.infoRow}>
                                            <Typography variant="body1" className={classes.name}>Cancelled At</Typography>
                                            <Typography variant="body1" className={classes.value}>{formatActivityTimestamp(new Date(metadata.cancelledAt))}</Typography>
                                        </div>
                                    )}
                                </CardContent>
                            </Card>
                        )}
                        {isOtcDetail && otcOrder?.metadata && Object.keys(otcOrder.metadata).length > 0 && (
                            <Card className={classes.infoCard}>
                                <CardContent className={classes.infoContent}>
                                    <Typography variant="overline" style={{fontSize: '0.75rem', fontWeight: 600, display: 'block', marginBottom: '8px'}}>
                                        Order Metadata
                                    </Typography>
                                    {Object.entries(otcOrder.metadata)
                                        .filter(([key, value]) => value != null && value !== '')
                                        .sort(([keyA], [keyB]) => {
                                            // Define preferred order
                                            const order = ['transactionDate'];
                                            const indexA = order.indexOf(keyA);
                                            const indexB = order.indexOf(keyB);
                                            if (indexA !== -1 && indexB !== -1) return indexA - indexB;
                                            if (indexA !== -1) return -1;
                                            if (indexB !== -1) return 1;
                                            return keyA.localeCompare(keyB);
                                        })
                                        .map(([key, value]) => {
                                            // Format the key for display
                                            const formatLabel = (str) => {
                                                const specialCases = {
                                                    'transactionDate': 'Transaction Date',
                                                    'payoutCurrency': 'Payout Currency',
                                                    'payoutAmount': 'Payout Amount',
                                                };
                                                if (specialCases[str]) return specialCases[str];
                                                return str.replace(/([A-Z])/g, ' $1').replace(/^./, (s) => s.toUpperCase()).trim();
                                            };
                                            
                                            // Format date/timestamp fields
                                            let displayValue = String(value);
                                            if (key.endsWith('At')) {
                                                // Full timestamp fields like 'completedAt'
                                                displayValue = formatActivityTimestamp(new Date(value));
                                            } else if (key.endsWith('Date') && value) {
                                                // Date-only fields like 'transactionDate' (YYYY-MM-DD)
                                                // Just display the date as-is without adding time
                                                displayValue = value;
                                            }
                                            
                                            return (
                                                <div key={key} className={classes.infoRow}>
                                                    <Typography variant="body1" className={classes.name}>{formatLabel(key)}</Typography>
                                                    <Typography variant="body1" className={classes.value}>{displayValue}</Typography>
                                                </div>
                                            );
                                        })}
                                </CardContent>
                            </Card>
                        )}
                        {isOtcDetail && isCompleted && otcOrder?.settlementDetails && (
                            <Card className={classes.infoCard}>
                                <CardContent className={classes.infoContent}>
                                    <Typography variant="body2" className={classes.sectionLabel}>
                                        Settlement Details
                                    </Typography>
                                    
                                    {Object.entries(settlementDetails)
                                        .filter(([key, value]) => {
                                            // Filter out null, undefined, empty strings, and system fields
                                            return value != null && value !== '' && key !== 'settlementType';
                                        })
                                        .sort(([keyA], [keyB]) => {
                                            // Define a preferred order for known fields
                                            const order = [
                                                'payoutAmount', 'payoutCurrency', 'quoteRate', 'midMarketRate', 
                                                'bps', 'totalFee', 'grossProfit', 'notes', 'transactionUrl'
                                            ];
                                            const indexA = order.indexOf(keyA);
                                            const indexB = order.indexOf(keyB);
                                            
                                            // If both keys are in order array, sort by their position
                                            if (indexA !== -1 && indexB !== -1) return indexA - indexB;
                                            // If only A is in order, it comes first
                                            if (indexA !== -1) return -1;
                                            // If only B is in order, it comes first
                                            if (indexB !== -1) return 1;
                                            // Otherwise, sort alphabetically
                                            return keyA.localeCompare(keyB);
                                        })
                                        .map(([key, value]) => {
                                            // Format the key for display (camelCase to Title Case)
                                            const formatLabel = (str) => {
                                                // Handle special cases
                                                const specialCases = {
                                                    'payoutAmount': 'USD Credited',
                                                    'payoutCurrency': 'Currency',
                                                    'quoteRate': 'Quote Rate',
                                                    'midMarketRate': 'Midmarket Rate',
                                                    'bps': 'Spread (BPS)',
                                                    'totalFee': 'Total Fee(USD)',
                                                    'grossProfit': 'Gross Profit(USD)',
                                                    'transactionUrl': 'Transaction URL',
                                                    'transactionFee': 'Transaction Fee',
                                                };
                                                
                                                if (specialCases[str]) return specialCases[str];
                                                
                                                // Default: Convert camelCase to Title Case
                                                return str
                                                    .replace(/([A-Z])/g, ' $1')
                                                    .replace(/^./, (s) => s.toUpperCase())
                                                    .trim();
                                            };
                                            
                                            // Special handling for transaction URL
                                            if (key === 'transactionUrl') {
                                                return (
                                                    <div key={key} className={classes.buttonRow}>
                                                        <ActionButton
                                                            variant={'text'}
                                                            onClick={() => window.open(value, '_blank')}
                                                        >
                                                            View transaction URL
                                                        </ActionButton>
                                                    </div>
                                                );
                                            }
                                            
                                            // Special formatting for combined payout display
                                            if (key === 'payoutAmount' && settlementDetails.payoutCurrency) {
                                                return (
                                                    <div key={key} className={classes.infoRow}>
                                                        <Typography variant="body1" className={classes.name}>
                                                            {formatLabel(key)}
                                                        </Typography>
                                                        <Typography variant="body1" className={classes.value}>
                                                            ${parseFloat(value).toFixed(2)} {settlementDetails.payoutCurrency}
                                                        </Typography>
                                                    </div>
                                                );
                                            }
                                            
                                            // Skip payoutCurrency if it's already shown with payoutAmount
                                            if (key === 'payoutCurrency') {
                                                return null;
                                            }
                                            
                                            // Default display
                                            return (
                                                <div key={key} className={classes.infoRow}>
                                                    <Typography variant="body1" className={classes.name}>
                                                        {formatLabel(key)}
                                                    </Typography>
                                                    <Typography variant="body1" className={classes.value}>
                                                        {typeof value === 'object' ? JSON.stringify(value) : String(value)}
                                                    </Typography>
                                                </div>
                                            );
                                        })}
                                </CardContent>
                            </Card>
                        )}
                        <OpsRole>
                            {transactionType === TRANSACTION_TYPES.PENDING_CREDIT && transactionCategory === TRANSACTION_CATEGORIES.DEPOSIT && resolvedLinkedTransaction && status === "Pending" &&
                                <div className={classes.buttonContainer}>
                                    <ModalConsumer>
                                        {({showModal}) => (
                                            <ActionButton
                                                onClick={() => showModal(CompleteTransactionDialog, {
                                                    accountId,
                                                    onComplete: refreshActivityList,
                                                    orderId: linkedOrderId,
                                                    amount: linkedAmount,
                                                    currency: linkedCurrency,
                                                    transactionType: TRANSACTION_TYPES.CREDIT,
                                                    transactionCategory: TRANSACTION_CATEGORIES.DEPOSIT,
                                                    selectableCurrencies: ["USD"]
                                                })}
                                                variant='primary'
                                                size='lg'
                                            >
                                                Complete
                                            </ActionButton>
                                        )}
                                    </ModalConsumer>
                                </div>
                            }
                            {transactionType === TRANSACTION_TYPES.PENDING_CREDIT && transactionCategory === TRANSACTION_CATEGORIES.DEPOSIT && resolvedLinkedTransaction && isFiat && status === "Pending" &&
                                <div style={{ marginTop: "16px"}} className={classes.buttonContainer}>
                                    <ModalConsumer>
                                        {({showModal}) => (
                                            <ActionButton
                                                onClick={() => showModal(RefundCancelTransactionDialog, {
                                                    accountId,
                                                    onComplete: refreshActivityList,
                                                    orderId: linkedOrderId,
                                                    amount: linkedAmount,
                                                    currency: linkedCurrency,
                                                    transactionCategory: TRANSACTION_CATEGORIES.DEPOSIT,
                                                    selectableCurrencies: ["AUD"]
                                                })}
                                                variant='cancel'
                                                size='lg'
                                            >
                                                Cancel
                                            </ActionButton>
                                        )}
                                    </ModalConsumer>
                                </div>
                            }
                            {/* OTC pending deposit: show Complete (opens modal) / Cancel */}
                            {isOtcDetail && status === "Pending" &&
                                <>
                                    <div className={classes.buttonContainer}>
                                        <ModalConsumer>
                                            {({ showModal }) => {
                                                // For OTC deposits, extract amount/currency from exchangeRateValue
                                                // which contains formatted amount like "$100.00" or "A$10.00"
                                                const parseDepositInfo = () => {
                                                    let currency = null;
                                                    let amount = null;
                                                    
                                                    // Try to extract from exchangeRateValue
                                                    // Formats: "$10.00", "A$10.00", "€10.00", "£10.00", "¥10.00", "USDT 10.00"
                                                    if (exchangeRateValue && typeof exchangeRateValue === 'string') {
                                                        // Remove any whitespace and extract the amount
                                                        const cleanValue = exchangeRateValue.trim();
                                                        
                                                        // Try matching patterns:
                                                        // 1. Currency code followed by amount: "AUD 10.00" or "USDT 10.00"
                                                        // 2. Symbol followed by amount: "$10.00", "A$10.00", "€10.00"
                                                        const patterns = [
                                                            /^([A-Z]{3,4})\s*([\d,]+\.?\d*)/, // "AUD 10.00"
                                                            /^A\$([\d,]+\.?\d*)/, // "A$10.00"
                                                            /^C\$([\d,]+\.?\d*)/, // "C$10.00"
                                                            /^NZ\$([\d,]+\.?\d*)/, // "NZ$10.00"
                                                            /^HK\$([\d,]+\.?\d*)/, // "HK$10.00"
                                                            /^S\$([\d,]+\.?\d*)/, // "S$10.00"
                                                            /^\$([\d,]+\.?\d*)/, // "$10.00"
                                                            /^€([\d,]+\.?\d*)/, // "€10.00"
                                                            /^£([\d,]+\.?\d*)/, // "£10.00"
                                                            /^¥([\d,]+\.?\d*)/, // "¥10.00"
                                                        ];
                                                        
                                                        for (const pattern of patterns) {
                                                            const match = cleanValue.match(pattern);
                                                            if (match) {
                                                                if (match[1] && match[2]) {
                                                                    // Currency code format: "AUD 10.00"
                                                                    currency = match[1];
                                                                    amount = parseFloat(match[2].replace(/,/g, ''));
                                                                } else if (match[1]) {
                                                                    // Symbol format - determine currency from symbol
                                                                    if (cleanValue.startsWith('A$')) currency = 'AUD';
                                                                    else if (cleanValue.startsWith('C$')) currency = 'CAD';
                                                                    else if (cleanValue.startsWith('NZ$')) currency = 'NZD';
                                                                    else if (cleanValue.startsWith('HK$')) currency = 'HKD';
                                                                    else if (cleanValue.startsWith('S$')) currency = 'SGD';
                                                                    else if (cleanValue.startsWith('$')) currency = 'USD';
                                                                    else if (cleanValue.startsWith('€')) currency = 'EUR';
                                                                    else if (cleanValue.startsWith('£')) currency = 'GBP';
                                                                    else if (cleanValue.startsWith('¥')) currency = 'JPY';
                                                                    amount = parseFloat(match[1].replace(/,/g, ''));
                                                                }
                                                                break;
                                                            }
                                                        }
                                                    }
                                                    
                                                    // Fallback to linkedTransaction if available
                                                    if (!currency && linkedCurrency) {
                                                        currency = linkedCurrency;
                                                        amount = linkedAmount;
                                                    }
                                                    
                                                    // Determine deposit type based on currency
                                                    // Stablecoins: USDT, USDC only
                                                    // Bank: all fiat currencies (USD, AUD, EUR, GBP, etc.)
                                                    const isStablecoin = currency && ['USDT', 'USDC'].includes(currency.toUpperCase());
                                                    const depositType = isStablecoin ? 'Stablecoin' : 'Bank';
                                                    
                                                    return {
                                                        type: depositType,
                                                        currency,
                                                        amount
                                                    };
                                                };
                                                
                                                return (
                                                    <ActionButton
                                                        onClick={() => showModal(CompleteOtcDepositDialog, {
                                                            orderId: activityReference,
                                                            onComplete: () => {
                                                                refreshActivityList && refreshActivityList();
                                                                onRefreshCustomer && onRefreshCustomer();
                                                                onReload && onReload();
                                                            },
                                                            initialValues: { currency: 'USD', amount: undefined },
                                                            depositInfo: parseDepositInfo()
                                                        })}
                                                        variant='primary'
                                                        size='lg'
                                                    >
                                                        Complete deposit
                                                    </ActionButton>
                                                );
                                            }}
                                        </ModalConsumer>
                                    </div>
                                    <div style={{ marginTop: "16px"}} className={classes.buttonContainer}>
                                        <ActionButton
                                            onClick={async () => {
                                                await client.mutate({
                                                    mutation: cancelOtcOrderMutation,
                                                    variables: { id: activityReference, input: { cancelledBy: user?.email } }
                                                });
                                                refreshActivityList && refreshActivityList();
                                                onRefreshCustomer && onRefreshCustomer();
                                                onReload && onReload();
                                            }}
                                            variant='cancel'
                                            size='lg'
                                        >
                                            Cancel
                                        </ActionButton>
                                    </div>
                                </>
                            }
                        </OpsRole>
                    </>
            }
        </div>
    )
}

const WithdrawActivityDetails = ({
                                     customerId,
                                     activityId,
                                     type,
                                     linkedTransaction,
                                     refreshActivityList,
                                     onRefreshCustomer,
                                     onReload,
                                     resource,
                                     isLoading,
                                     parentError,
                                     customer,
                                     onClose,
                                     orderId,
                                     activityReference
                                 }) => {
    const history = useHistory();
    const { user } = useAuth0();
    const [data, setData] = useState({})
    const [refresh, setRefresh] = useState(false)
    const [loading, setLoading] = useState(isLoading);
    const [error, setError] = useState(parentError);
    const dataProvider = useDataProvider();
    useEffect(() => {
        setRefresh(true)
    }, [])
    useEffect(() => {
        if (refresh === true) {
            setLoading(true)
            dataProvider.getOne(resource, {customerId, activityId, type, orderId})
                .then(({data}) => {
                    setData(data);
                })
                .catch((error) => {
                    setError(error)
                })
                .finally(() => {
                    setLoading(false)
                    setRefresh(false)
                });
        }
    }, [refresh])
    const {
        categoryName,
        heading,
        status,
        transactionDate,
        reference,
        transferMethodName,
        transferMethodValue,
        exchangeRateName,
        exchangeRateValue,
        blockchainNetwork,
        totalFee,
        sentAmount,
        blockchainScanLink
    } = data
    const resolvedTransaction = linkedTransaction ?? data["linkedTransaction"] ?? {}
    const {
        accountId,
        amount: linkedAmount,
        currency: linkedCurrency,
        orderId: linkedOrderId,
        type: transactionType,
        category: transactionCategory,
    } = resolvedTransaction
    const classes = useDetailStyles();
    // Treat as OTC only if heading contains "(OTC)" marker from BFF
    const isOtcDetail = heading?.toLowerCase()?.includes('(otc)');
    // Metadata is now in the activity data itself
    const metadata = data?.metadata;
    const shouldShowMetadata = metadata && (metadata.createdByEmail || metadata.completedByEmail || metadata.completedAt || metadata.cancelledByEmail || metadata.cancelledAt);
    
    return (
        <div className={classes.root}>
            {(error || (!data && !loading)) ?
                <div className={classes.errorContainer}>
                    <GenericError onClick={() => setRefresh(true)} className={classes.error}/>
                </div>
                : loading ?
                    <div className={classes.resultContainer}>
                        <CircularLoader className={classes.loader} trigger={loading} loaderSize='125px'/>
                    </div>
                    :
                    <>
                        <Typography variant='button' className={classes.category}>
                            {categoryName}
                        </Typography>
                        <Typography variant='h2' className={classes.heading}>
                            {heading}
                        </Typography>
                        {customer && <Card className={classes.infoCard}>
                            <CardContent className={classes.infoContent}>
                                <div className={classes.infoRow}>
                                    <Typography variant="body1" className={classes.name}>Customer</Typography>
                                    <Typography variant="body1"
                                                onClick={() => {
                                                    history.push(`/customers/${customer.id}/show`);
                                                    onClose();
                                                }}
                                                className={`${classes.value} ${classes.linkValue}`}>{customer.name}</Typography>
                                </div>
                                <div className={classes.infoRow}>
                                    <Typography variant="body1" className={classes.name}>Customer ID</Typography>
                                    <Typography variant="body1" className={classes.value}>{customer.id}</Typography>
                                </div>
                            </CardContent>
                        </Card>}
                        <Card className={classes.infoCard}>
                            <CardContent className={classes.infoContent}>
                                <div className={classes.infoRow}>
                                    <Typography variant="body1" className={classes.name}>Created At</Typography>
                                    <Typography variant="body1"
                                                className={classes.value}>{`${formatActivityTimestamp(transactionDate)}`}</Typography>
                                </div>
                                {
                                    transferMethodName && transferMethodValue &&
                                    <div className={classes.infoRow}>
                                        <Typography variant="body1"
                                                    className={classes.name}>{transferMethodName}</Typography>
                                        <Typography variant="body1"
                                                    className={classes.value}>{transferMethodValue}</Typography>
                                    </div>
                                }
                                {
                                    blockchainNetwork &&
                                    <div className={classes.infoRow}>
                                        <Typography variant="body1" className={classes.name}>Network</Typography>
                                        <Typography variant="body1"
                                                    className={classes.value}>{blockchainNetwork}</Typography>
                                    </div>
                                }
                                {
                                    reference &&
                                    <div className={classes.infoRow}>
                                        <Typography variant="body1" className={classes.name}>Reference</Typography>
                                        <Typography variant="body1" className={classes.value}>{reference}</Typography>
                                    </div>
                                }
                                {
                                    activityReference &&
                                    <div className={classes.infoRow}>
                                        <Typography variant="body1" className={classes.name}>OrderID</Typography>
                                        <Typography variant="body1"
                                                    className={classes.value}>{activityReference}</Typography>
                                    </div>
                                }
                                <Divider
                                    className={classes.divider}
                                    orientation="horizontal"
                                    variant="fullWidth"
                                />
                                {
                                    exchangeRateName && exchangeRateValue &&
                                    <div className={classes.infoRow}>
                                        <Typography variant="body1"
                                                    className={classes.name}>{exchangeRateName}</Typography>
                                        <Typography variant="body1"
                                                    className={classes.value}>{exchangeRateValue}</Typography>
                                    </div>
                                }
                                {
                                    sentAmount &&
                                    <div className={classes.infoRow}>
                                        <Typography variant="body1" className={classes.name}>Sent</Typography>
                                        <Typography variant="body1" className={classes.value}>{sentAmount}</Typography>
                                    </div>
                                }
                                {
                                    totalFee &&
                                    <div className={classes.infoRow}>
                                        <Typography variant="body1" className={classes.name}>Fee</Typography>
                                        <Typography variant="body1" className={classes.value}>{totalFee}</Typography>
                                    </div>
                                }
                                <div className={classes.infoRow}>
                                    <Typography variant="body1" className={classes.name}>Status</Typography>
                                    <Typography variant="body1" className={classes.value}>{status}</Typography>
                                </div>
                                {blockchainScanLink && <div className={classes.buttonRow}>
                                    <ActionButton
                                        variant={'text'}
                                        onClick={() => window.open(blockchainScanLink, '_blank')}
                                    >
                                        View in explorer
                                    </ActionButton>
                                </div>}
                            </CardContent>
                        </Card>
                        {shouldShowMetadata && (
                            <Card className={classes.infoCard}>
                                <CardContent className={classes.infoContent}>
                                    {metadata.createdByEmail && (
                                        <div className={classes.infoRow}>
                                            <Typography variant="body1" className={classes.name}>Created By</Typography>
                                            <Typography variant="body1" className={classes.value}>{metadata.createdByEmail}</Typography>
                                        </div>
                                    )}
                                    {metadata.completedByEmail && (
                                        <div className={classes.infoRow}>
                                            <Typography variant="body1" className={classes.name}>Completed By</Typography>
                                            <Typography variant="body1" className={classes.value}>{metadata.completedByEmail}</Typography>
                                        </div>
                                    )}
                                    {metadata.completedAt && (
                                        <div className={classes.infoRow}>
                                            <Typography variant="body1" className={classes.name}>Completed At</Typography>
                                            <Typography variant="body1" className={classes.value}>{formatActivityTimestamp(new Date(metadata.completedAt))}</Typography>
                                        </div>
                                    )}
                                    {metadata.cancelledByEmail && (
                                        <div className={classes.infoRow}>
                                            <Typography variant="body1" className={classes.name}>Cancelled By</Typography>
                                            <Typography variant="body1" className={classes.value}>{metadata.cancelledByEmail}</Typography>
                                        </div>
                                    )}
                                    {metadata.cancelledAt && (
                                        <div className={classes.infoRow}>
                                            <Typography variant="body1" className={classes.name}>Cancelled At</Typography>
                                            <Typography variant="body1" className={classes.value}>{formatActivityTimestamp(new Date(metadata.cancelledAt))}</Typography>
                                        </div>
                                    )}
                                </CardContent>
                            </Card>
                        )}
                        <OpsRole>
                            {transactionType === TRANSACTION_TYPES.PENDING_DEBIT && transactionCategory === TRANSACTION_CATEGORIES.WITHDRAWAL && resolvedTransaction && status === "Pending" &&
                                <>
                                    <div className={classes.buttonContainer}>
                                        <ModalConsumer>
                                            {({showModal}) => (
                                                <ActionButton
                                                    onClick={() => showModal(CompleteTransactionDialog, {
                                                        accountId,
                                                        onComplete: refreshActivityList,
                                                        orderId: linkedOrderId,
                                                        amount: linkedAmount,
                                                        currency: linkedCurrency,
                                                        transactionType: TRANSACTION_TYPES.DEBIT,
                                                        transactionCategory: TRANSACTION_CATEGORIES.WITHDRAWAL,
                                                        selectableCurrencies: ["USD"]
                                                    })}
                                                    variant='primary'
                                                    size='lg'
                                                >
                                                    Complete transaction
                                                </ActionButton>
                                            )}
                                        </ModalConsumer>
                                    </div>
                                </>
                            }
                            {/* OTC pending withdraw/send: show Complete using OTC endpoint */}
                            {isOtcDetail && status === "Pending" &&
                                <>
                                    <div className={classes.buttonContainer}>
                                        <ActionButton
                                            onClick={async () => {
                                                await client.mutate({
                                                    mutation: completeOtcOrderMutation,
                                                    variables: { 
                                                        id: activityReference, 
                                                        input: { 
                                                            createdBy: user?.email,
                                                            settlementDetails: {}
                                                        }
                                                    }
                                                });
                                                refreshActivityList && refreshActivityList();
                                                onRefreshCustomer && onRefreshCustomer();
                                                onReload && onReload();
                                            }}
                                            variant='primary'
                                            size='lg'
                                        >
                                            Complete transaction
                                        </ActionButton>
                                    </div>
                                    <div style={{ marginTop: "16px"}} className={classes.buttonContainer}>
                                        <ActionButton
                                            onClick={async () => {
                                                await client.mutate({
                                                    mutation: cancelOtcOrderMutation,
                                                    variables: { id: activityReference, input: { cancelledBy: user?.email } }
                                                });
                                                refreshActivityList && refreshActivityList();
                                                onRefreshCustomer && onRefreshCustomer();
                                                onReload && onReload();
                                            }}
                                            variant='cancel'
                                            size='lg'
                                        >
                                            Cancel
                                        </ActionButton>
                                    </div>
                                </>
                            }
                        </OpsRole>
                    </>
            }
        </div>
    )
}

const PaymentActivityDetails = ({
                                    customerId,
                                    activityId,
                                    type,
                                    resource,
                                    activityReference,
                                    isLoading,
                                    parentError,
                                    onClose,
                                    customer
                                }) => {
    const history = useHistory();
    const [data, setData] = useState({})
    const [refresh, setRefresh] = useState(false)
    const [loading, setLoading] = useState(isLoading);
    const [error, setError] = useState(parentError);
    const dataProvider = useDataProvider();
    useEffect(() => {
        setRefresh(true)
    }, [])
    useEffect(() => {
        if (refresh == true) {
            setLoading(true)
            dataProvider.getOne(resource, {customerId, activityId, type})
                .then(({data}) => {
                    setData(data);
                })
                .catch((error) => {
                    setError(error)
                })
                .finally(() => {
                    setLoading(false)
                    setRefresh(false)
                });
        }
    }, [refresh])
    const {
        categoryName,
        heading,
        status,
        transactionDate,
        reference,
        exchangeRateName,
        exchangeRateValue,
        cardLastFourDigits,
        transactionFee
    } = data
    const classes = useDetailStyles();
    return (
        <div className={classes.root}>
            {(error || (!data && !loading)) ?
                <div className={classes.errorContainer}>
                    <GenericError onClick={() => setRefresh(true)} className={classes.error}/>
                </div>
                : loading ?
                    <div className={classes.resultContainer}>
                        <CircularLoader className={classes.loader} trigger={loading} loaderSize='125px'/>
                    </div>
                    :
                    <>
                        <Typography variant='button' className={classes.category}>
                            {categoryName}
                        </Typography>
                        <Typography variant='h2' className={classes.heading}>
                            {heading}
                        </Typography>
                        {customer && <Card className={classes.infoCard}>
                            <CardContent className={classes.infoContent}>
                                <div className={classes.infoRow}>
                                    <Typography variant="body1" className={classes.name}>Customer</Typography>
                                    <Typography variant="body1"
                                                onClick={() => {
                                                    history.push(`/customers/${customer.id}/show`);
                                                    onClose();
                                                }}
                                                className={`${classes.value} ${classes.linkValue}`}>{customer.name}</Typography>
                                </div>
                                <div className={classes.infoRow}>
                                    <Typography variant="body1" className={classes.name}>Customer ID</Typography>
                                    <Typography variant="body1" className={classes.value}>{customer.id}</Typography>
                                </div>
                            </CardContent>
                        </Card>}
                        <Card className={classes.infoCard}>
                            <CardContent className={classes.infoContent}>
                                <div className={classes.infoRow}>
                                    <Typography variant="body1" className={classes.name}>Created At</Typography>
                                    <Typography variant="body1"
                                                className={classes.value}>{`${formatActivityTimestamp(transactionDate)}`}</Typography>
                                </div>
                                {
                                    cardLastFourDigits &&
                                    <div className={classes.infoRow}>
                                        <Typography variant="body1" className={classes.name}>From Stables
                                            Card</Typography>
                                        <Typography variant="body1"
                                                    className={classes.value}>{cardLastFourDigits}</Typography>
                                    </div>
                                }
                                {
                                    reference &&
                                    <div className={classes.infoRow}>
                                        <Typography variant="body1" className={classes.name}>Reference</Typography>
                                        <Typography variant="body1" className={classes.value}>{reference}</Typography>
                                    </div>
                                }
                                {
                                    activityReference &&
                                    <div className={classes.infoRow}>
                                        <Typography variant="body1" className={classes.name}>OrderID</Typography>
                                        <Typography variant="body1"
                                                    className={classes.value}>{activityReference}</Typography>
                                    </div>
                                }
                                <Divider
                                    className={classes.divider}
                                    orientation="horizontal"
                                    variant="fullWidth"
                                />
                                {
                                    exchangeRateName && exchangeRateValue &&
                                    <div className={classes.infoRow}>
                                        <Typography variant="body1"
                                                    className={classes.name}>{exchangeRateName}</Typography>
                                        <Typography variant="body1"
                                                    className={classes.value}>{exchangeRateValue}</Typography>
                                    </div>
                                }
                                {
                                    transactionFee &&
                                    <div className={classes.infoRow}>
                                        <Typography variant="body1" className={classes.name}>Transaction
                                            Fee</Typography>
                                        <Typography variant="body1"
                                                    className={classes.value}>{transactionFee}</Typography>
                                    </div>
                                }
                                <div className={classes.infoRow}>
                                    <Typography variant="body1" className={classes.name}>Status</Typography>
                                    <Typography variant="body1" className={classes.value}>{status}</Typography>
                                </div>
                            </CardContent>
                        </Card>
                    </>
            }
        </div>
    )
}

const RefundActivityDetails = ({customerId, activityId, type, resource, orderId, activityReference, isLoading, customer, onClose}) => {
    const history = useHistory();
    const [data, setData] = useState({})
    const [refresh, setRefresh] = useState(false)
    const [loading, setLoading] = useState(isLoading);
    const [error, setError] = useState();
    const dataProvider = useDataProvider();
    useEffect(() => {
        setRefresh(true)
    }, [])
    useEffect(() => {
        if (refresh == true) {
            setLoading(true)
            dataProvider.getOne(resource, {customerId, activityId, type, orderId})
                .then(({data}) => {
                    setData(data);
                })
                .catch((error) => {
                    setError(error)
                })
                .finally(() => {
                    setLoading(false)
                    setRefresh(false)
                });
        }
    }, [refresh])
    const {
        categoryName,
        heading,
        status,
        transactionDate,
        reference,
        exchangeRateName,
        exchangeRateValue,
        cardLastFourDigits,
    } = data
    const classes = useDetailStyles();
    return (
        <div className={classes.root}>
            {(error || (!data && !loading)) ?
                <div className={classes.errorContainer}>
                    <GenericError onClick={() => setRefresh(true)} className={classes.error}/>
                </div>
                : loading ?
                    <div className={classes.resultContainer}>
                        <CircularLoader className={classes.loader} trigger={loading} loaderSize='125px'/>
                    </div>
                    :
                    <>
                        <Typography variant='button' className={classes.category}>
                            {categoryName}
                        </Typography>
                        <Typography variant='h2' className={classes.heading}>
                            {heading}
                        </Typography>
                        {customer && <Card className={classes.infoCard}>
                            <CardContent className={classes.infoContent}>
                                <div className={classes.infoRow}>
                                    <Typography variant="body1" className={classes.name}>Customer</Typography>
                                    <Typography variant="body1"
                                                onClick={() => {
                                                    history.push(`/customers/${customer.id}/show`);
                                                    onClose();
                                                }}
                                                className={`${classes.value} ${classes.linkValue}`}>{customer.name}</Typography>
                                </div>
                                <div className={classes.infoRow}>
                                    <Typography variant="body1" className={classes.name}>Customer ID</Typography>
                                    <Typography variant="body1" className={classes.value}>{customer.id}</Typography>
                                </div>
                            </CardContent>
                        </Card>}
                        <Card className={classes.infoCard}>
                            <CardContent className={classes.infoContent}>
                                <div className={classes.infoRow}>
                                    <Typography variant="body1" className={classes.name}>Created At</Typography>
                                    <Typography variant="body1"
                                                className={classes.value}>{`${formatActivityTimestamp(transactionDate)}`}</Typography>
                                </div>
                                {
                                    cardLastFourDigits &&
                                    <div className={classes.infoRow}>
                                        <Typography variant="body1" className={classes.name}>To Stables
                                            Card</Typography>
                                        <Typography variant="body1"
                                                    className={classes.value}>{cardLastFourDigits}</Typography>
                                    </div>
                                }
                                {
                                    reference &&
                                    <div className={classes.infoRow}>
                                        <Typography variant="body1" className={classes.name}>Reference</Typography>
                                        <Typography variant="body1" className={classes.value}>{reference}</Typography>
                                    </div>
                                }
                                {
                                    activityReference &&
                                    <div className={classes.infoRow}>
                                        <Typography variant="body1" className={classes.name}>OrderID</Typography>
                                        <Typography variant="body1"
                                                    className={classes.value}>{activityReference}</Typography>
                                    </div>
                                }
                                <Divider
                                    className={classes.divider}
                                    orientation="horizontal"
                                    variant="fullWidth"
                                />
                                {
                                    exchangeRateName && exchangeRateValue &&
                                    <div className={classes.infoRow}>
                                        <Typography variant="body1"
                                                    className={classes.name}>{exchangeRateName}</Typography>
                                        <Typography variant="body1"
                                                    className={classes.value}>{exchangeRateValue}</Typography>
                                    </div>
                                }
                                <div className={classes.infoRow}>
                                    <Typography variant="body1" className={classes.name}>Status</Typography>
                                    <Typography variant="body1" className={classes.value}>{status}</Typography>
                                </div>
                            </CardContent>
                        </Card>
                    </>
            }
        </div>
    )
}

const SentActivityDetails = ({
                                 customerId,
                                 activityId,
                                 type,
                                 linkedTransaction,
                                 refreshActivityList,
                                 onRefreshCustomer,
                                 onReload,
                                 resource,
                                 activityReference,
                                 isLoading,
                                 parentError,
                                 onClose,
                                 customer,
                                 isOtcDeposit
                             }) => {
    const history = useHistory();
    const { user } = useAuth0();
    const [data, setData] = useState({})
    const [order, setOrder] = useState({})
    const [otcOrderDetails, setOtcOrderDetails] = useState(null)
    const [otcOrder, setOtcOrder] = useState(null)
    const [manualSendReference, setManualSendReference] = useState(null)
    const [refresh, setRefresh] = useState(false)
    const [loading, setLoading] = useState(isLoading);
    const [error, setError] = useState(parentError);
    const dataProvider = useDataProvider();
    useEffect(() => {
        setRefresh(true)
    }, [])
    useEffect(() => {
        if (refresh === true) {
            setLoading(true)
            // For onchain sends, use activityId. For OTC orders, activityReference contains the OTC order ID.
            const fetchId = activityId || activityReference;
            dataProvider.getOne(resource, {customerId, activityId: fetchId, type, activityReference, isOtcDeposit})
                .then(({data}) => {
                    setData(data);
                })
                .catch((error) => {
                    setError(error)
                })
                .finally(() => {
                    setLoading(false)
                    setRefresh(false)
                });
        }
    }, [refresh])
    const {
        categoryName,
        heading,
        status,
        recipientName,
        sentAmount,
        tagline,
        transactionDate,
        transactionFee,
        blockchainNetwork,
        blockchainScanLink,
        reference,
        transferMethodName,
        transferMethodValue,
        exchangeRateName,
        exchangeRateValue,
        totalFee,
        totalCost
    } = data
    const {paymentAdditionalData: {destinationChannelName: destinationChannel} = {}} = order
    const isBank = transferMethodName === "To bank account"
    const isEWallet = transferMethodName === "To e-wallet"
    const isFiat = isBank || isEWallet
    const isPending = status === "Pending"
    const isTronNetwork = blockchainNetwork?.toLowerCase() === "tron"
    const isUsdt = sentAmount?.toUpperCase()?.includes("USDT")
    const showTronManualButtons = !isFiat && isPending && isTronNetwork && isUsdt
    const displayReference = showTronManualButtons ? manualSendReference : reference
    const canRenderTronManualButtons = showTronManualButtons && Boolean(manualSendReference)
    // Metadata is now in the activity data itself
    const metadata = data?.metadata;
    const shouldShowMetadata = metadata && (metadata.createdByEmail || metadata.completedByEmail || metadata.completedAt || metadata.cancelledByEmail || metadata.cancelledAt);
    
    useEffect(() => {
        const hasReference = Boolean(reference);
        const hasActivityReference = Boolean(activityReference);
        if (!hasReference && !hasActivityReference) {
            return;
        }

        setLoading(true)

        const fetchOrder = activityReference
            ? dataProvider.getOne('orders', { orderId: activityReference })
            : dataProvider.getManyReference('orders', { reference });

        fetchOrder
            .then((orders) => {
                const orderData = activityReference ? orders.data : orders.data?.[0];
                if (orderData) {
                    setOrder(orderData)
                }
            })
            .catch((_ignored) => {
                // Optional order lookup may fail for OTC. Ignore to allow detail to render.
            })
            .finally(() => {
                setLoading(false)
            });
    }, [reference, activityReference, dataProvider]);

    useEffect(() => {
        if (!showTronManualButtons || !activityReference) {
            setManualSendReference(null);
            return;
        }

        dataProvider.getOne('orderReferences', { orderId: activityReference })
            .then(({ data }) => {
                setManualSendReference(data.reference || null);
            })
            .catch((_ignored) => {
                // Optional reference lookup; ignore failures for OTC
            });
    }, [showTronManualButtons, activityReference, dataProvider]);
    
    // Fetch OTC order details for the confirmation modal
    useEffect(() => {
        const isOtcRef = Boolean(activityReference);
        if (!isOtcRef) return;
        
        client.query({
            query: getOtcOrderQuery,
            variables: { id: activityReference },
            fetchPolicy: 'network-only'
        })
        .then(({ data }) => {
            if (data?.otcOrder_Admin) {
                const order = data.otcOrder_Admin;
                setOtcOrder(order);
                const metadata = order.metadata || {};
                
                // Extract payout details from metadata (where they're stored in the database)
                const payoutCurrency = metadata.payoutCurrency || order.currency;
                const payoutAmount = metadata.payoutAmount 
                    ? parseFloat(metadata.payoutAmount) 
                    : order.amount;
                
                // Calculate exchange rate
                const calculateFxRate = () => {
                    // First try to get from metadata (could be 'quoteRate' or 'fxRate')
                    const metadataRate = metadata.quoteRate || metadata.fxRate || order.fxRate;
                    if (metadataRate) {
                        return parseFloat(metadataRate);
                    }
                    
                    // Calculate from amounts if available
                    if (order.debitAmountUsd && payoutAmount && order.debitAmountUsd > 0) {
                        return parseFloat((payoutAmount / order.debitAmountUsd).toFixed(4));
                    }
                    
                    return 1;
                };
                
                setOtcOrderDetails({
                    customerId: order.customerId,
                    sourceCurrency: 'USD',
                    sourceAmount: order.debitAmountUsd,
                    debitAmountUsd: order.debitAmountUsd,
                    payoutCurrency: payoutCurrency,
                    payoutAmount: payoutAmount,
                    fxRate: calculateFxRate(),
                    recipientDetails: order.recipientDetails
                });
            }
        })
        .catch((err) => {
            console.error('Failed to fetch OTC order details:', err);
        });
    }, [activityReference]);
    const {
        accountId,
        id,
        amount,
        currency,
        status: orderStatus
    } = order
    const orderIsPending = orderStatus === "PENDING"
    const retryIcon = <RetryIcon/>
    const classes = useDetailStyles();
    // Treat as OTC based on the type prop
    const isOtcDetail = type === ACTIVITY_TYPES.OTC_ORDER;
    const parsedOtcAmount = (() => {
        // Prefer OTC detail amount (e.g., "$100.00"), else fall back to order.amount
        const raw = data?.sentAmount;
        if (raw && typeof raw === 'string') {
            const m = raw.match(/([\d.,]+)/);
            if (m && m[1]) {
                try { return parseFloat(m[1].replace(/,/g, '')); } catch (e) { /* noop */ }
            }
        }
        return typeof amount === 'number' ? amount : undefined;
    })();
    return (
        <div className={classes.root}>
            {(error || (!data && !loading)) ?
                <div className={classes.errorContainer}>
                    <GenericError onClick={() => setRefresh(true)} className={classes.error}/>
                </div>
                : loading ?
                    <div className={classes.resultContainer}>
                        <CircularLoader className={classes.loader} trigger={loading} loaderSize='125px'/>
                    </div>
                    :
                    <>
                        <Typography variant='button' className={classes.category}>
                            {categoryName}
                        </Typography>
                        <Typography variant='h2' className={classes.heading}>
                            {heading}
                        </Typography>
                        <Typography variant='h4' className={classes.heading}>
                            {tagline}
                        </Typography>
                        {customer && <Card className={classes.infoCard}>
                            <CardContent className={classes.infoContent}>
                                <div className={classes.infoRow}>
                                    <Typography variant="body1" className={classes.name}>Customer</Typography>
                                    <Typography variant="body1"
                                                onClick={() => {
                                                    history.push(`/customers/${customer.id}/show`);
                                                    onClose();
                                                }}
                                                className={`${classes.value} ${classes.linkValue}`}>{customer.name}</Typography>
                                </div>
                                <div className={classes.infoRow}>
                                    <Typography variant="body1" className={classes.name}>Customer ID</Typography>
                                    <Typography variant="body1" className={classes.value}>{customer.id}</Typography>
                                </div>
                            </CardContent>
                        </Card>}
                        <Card className={classes.infoCard}>
                            <CardContent className={classes.infoContent}>
                                <div className={classes.infoRow}>
                                    <Typography variant="body1" className={classes.name}>Created At</Typography>
                                    <Typography variant="body1"
                                                className={classes.value}>{`${formatActivityTimestamp(transactionDate)}`}</Typography>
                                </div>
                                {
                                    isFiat ?
                                        <div className={classes.infoRow}>
                                            <Typography variant="body1"
                                                        className={classes.name}>{transferMethodName}</Typography>
                                            <Typography variant="body1"
                                                        className={classes.value}>{isBank ? `${destinationChannel || "Unknown"}${transferMethodValue ? "  •  " + transferMethodValue : ""}` : transferMethodValue}</Typography>
                                        </div>
                                        : recipientName &&
                                        <div className={classes.infoRow}>
                                            <Typography variant="body1" className={classes.name}>To</Typography>
                                            <Typography variant="body1"
                                                        className={classes.value}>{recipientName}</Typography>
                                        </div>
                                }
                                {
                                    !isFiat && blockchainNetwork &&
                                    <div className={classes.infoRow}>
                                        <Typography variant="body1" className={classes.name}>Network</Typography>
                                        <Typography variant="body1"
                                                    className={classes.value}>{blockchainNetwork}</Typography>
                                    </div>
                                }
                                {
                                    reference && !isOtcDetail &&
                                    <div className={classes.infoRow}>
                                        <Typography variant="body1" className={classes.name}>Reference</Typography>
                                        <Typography variant="body1" className={classes.value}>{reference}</Typography>
                                    </div>
                                }
                                {
                                    activityReference &&
                                    <div className={classes.infoRow}>
                                        <Typography variant="body1" className={classes.name}>OrderID</Typography>
                                        <Typography variant="body1"
                                                    className={classes.value}>{activityReference}</Typography>
                                    </div>
                                }
                                <Divider
                                    className={classes.divider}
                                    orientation="horizontal"
                                    variant="fullWidth"
                                />
                                {
                                    sentAmount &&
                                    <div className={classes.infoRow}>
                                        <Typography variant="body1"
                                                    className={classes.name}>Sent</Typography>
                                        <Typography variant="body1"
                                                    className={classes.value}>
                                            {isOtcDetail && otcOrderDetails 
                                                ? `${otcOrderDetails.payoutAmount} ${otcOrderDetails.payoutCurrency}`
                                                : sentAmount}
                                        </Typography>
                                    </div>
                                }
                                {
                                    isOtcDetail && otcOrderDetails?.debitAmountUsd && (
                                        <div className={classes.infoRow}>
                                            <Typography variant="body1" className={classes.name}>Cost</Typography>
                                            <Typography variant="body1" className={classes.value}>
                                                ${parseFloat(otcOrderDetails.debitAmountUsd).toFixed(2)} USD
                                            </Typography>
                                        </div>
                                    )
                                }
                                {/* Recipient details section for OTC sends */}
                                {
                                    isOtcDetail && otcOrderDetails?.recipientDetails && (
                                        <>
                                            {Object.entries(otcOrderDetails.recipientDetails)
                                                .filter(([key, value]) => value != null && value !== '')
                                                .map(([key, value]) => {
                                                    // Format the key for display (camelCase to Title Case)
                                                    const formatLabel = (str) => {
                                                        return str
                                                            .replace(/([A-Z])/g, ' $1')
                                                            .replace(/^./, (s) => s.toUpperCase())
                                                            .trim();
                                                    };

                                                    return (
                                                        <div key={key} className={classes.infoRow}>
                                                            <Typography variant="body1" className={classes.name}>
                                                                {formatLabel(key)}
                                                            </Typography>
                                                            <Typography variant="body1" className={classes.value}>
                                                                {typeof value === 'object' ? JSON.stringify(value) : String(value)}
                                                            </Typography>
                                                        </div>
                                                    );
                                                })}
                                        </>
                                    )
                                }
                                {
                                    totalFee &&
                                    <div className={classes.infoRow}>
                                        <Typography variant="body1"
                                                    className={classes.name}>Transaction fee</Typography>
                                        <Typography variant="body1"
                                                    className={classes.value}>{totalFee}</Typography>
                                    </div>
                                }
                                {
                                    transactionFee &&
                                    <div className={classes.infoRow}>
                                        <Typography variant="body1"
                                                    className={classes.name}>Transaction fee</Typography>
                                        <Typography variant="body1"
                                                    className={classes.value}>{transactionFee}</Typography>
                                    </div>
                                }
                                {
                                    totalCost &&
                                    <div className={classes.infoRow}>
                                        <Typography variant="body1"
                                                    className={classes.name}>Total cost</Typography>
                                        <Typography variant="body1"
                                                    className={classes.value}>{totalCost}</Typography>
                                    </div>
                                }
                                <div className={classes.statusRow}>
                                    <Typography variant="body1" className={classes.name}>Status</Typography>
                                    {isFiat && order && isPending && orderIsPending &&
                                        <OpsRole>
                                            <ModalConsumer>
                                                { ({ showModal }) => (
                                                    <ActionButton className={classes.retry} style={{marginLeft: "60px"}}
                                                        variant={'text'}
                                                        onClick={ () => showModal(ConfirmTransactionDialog, {
                                                          accountId,
                                                          onComplete: refreshActivityList,
                                                          orderId: id,
                                                          amount: amount,
                                                          currency: currency,
                                                          label: "retry",
                                                          transactionType: TRANSACTION_TYPES.RETRY_SEND_FIAT,
                                                          transactionCategory: TRANSACTION_CATEGORIES.ADJUSTMENT,
                                                          selectableCurrencies: ["USD"]
                                                        }) }
                                                      >
                                                        {retryIcon} Retry
                                                    </ActionButton>
                                                ) }
                                            </ModalConsumer>
                                        </OpsRole>
                                    }
                                    <Typography variant="body1" className={classes.value} style={{marginLeft: "auto"}}>{status}</Typography>
                                </div>

                                {/* OTC placeholders: show Complete/Cancel buttons for OTC sends (will wire later) */}
                                {isOtcDetail && status === "Pending" &&
                                  <AdminOrExternalOpsRole>
                                      <div className={classes.buttonContainer}>
                                          <ModalConsumer>
                                              {({ showModal }) => (
                                                <ActionButton
                                                  onClick={() => showModal(CompleteOtcSendDialog, {
                                                    orderId: activityReference || reference,
                                                    orderDetails: otcOrderDetails || {
                                                      customerId: customerId,
                                                      sourceCurrency: 'USD',
                                                      sourceAmount: 0,
                                                      payoutCurrency: currency || 'USD',
                                                      payoutAmount: parsedOtcAmount || 0,
                                                      fxRate: 1
                                                    },
                                                    onComplete: () => {
                                                        refreshActivityList && refreshActivityList();
                                                        onRefreshCustomer && onRefreshCustomer();
                                                        onReload && onReload();
                                                    }
                                                  })}
                                                  variant='primary'
                                                  size='lg'
                                                >
                                                  Complete
                                                </ActionButton>
                                              )}
                                          </ModalConsumer>
                                      </div>
                                      <div style={{ marginTop: "16px"}} className={classes.buttonContainer}>
                                          <ActionButton
                                              onClick={async () => {
                                                  if (activityReference) {
                                                      await client.mutate({
                                                          mutation: cancelOtcOrderMutation,
                                                          variables: { id: activityReference, input: { cancelledBy: user?.email } }
                                                      });
                                                      refreshActivityList && refreshActivityList();
                                                      onRefreshCustomer && onRefreshCustomer();
                                                      onReload && onReload();
                                                  }
                                              }}
                                              variant='primary'
                                              size='lg'
                                          >
                                              Cancel
                                          </ActionButton>
                                      </div>
                                  </AdminOrExternalOpsRole>
                                }

                                {blockchainScanLink && <div className={classes.buttonRow}>
                                    <ActionButton
                                        variant={'text'}
                                        onClick={() => window.open(blockchainScanLink, '_blank')}
                                    >
                                        View in explorer
                                    </ActionButton>
                                </div>}
                            </CardContent>
                        </Card>
                        {shouldShowMetadata && (
                            <Card className={classes.infoCard}>
                                <CardContent className={classes.infoContent}>
                                    {metadata.createdByEmail && (
                                        <div className={classes.infoRow}>
                                            <Typography variant="body1" className={classes.name}>Created By</Typography>
                                            <Typography variant="body1" className={classes.value}>{metadata.createdByEmail}</Typography>
                                        </div>
                                    )}
                                    {metadata.completedByEmail && (
                                        <div className={classes.infoRow}>
                                            <Typography variant="body1" className={classes.name}>Completed By</Typography>
                                            <Typography variant="body1" className={classes.value}>{metadata.completedByEmail}</Typography>
                                        </div>
                                    )}
                                    {metadata.completedAt && (
                                        <div className={classes.infoRow}>
                                            <Typography variant="body1" className={classes.name}>Completed At</Typography>
                                            <Typography variant="body1" className={classes.value}>{formatActivityTimestamp(new Date(metadata.completedAt))}</Typography>
                                        </div>
                                    )}
                                    {metadata.cancelledByEmail && (
                                        <div className={classes.infoRow}>
                                            <Typography variant="body1" className={classes.name}>Cancelled By</Typography>
                                            <Typography variant="body1" className={classes.value}>{metadata.cancelledByEmail}</Typography>
                                        </div>
                                    )}
                                    {metadata.cancelledAt && (
                                        <div className={classes.infoRow}>
                                            <Typography variant="body1" className={classes.name}>Cancelled At</Typography>
                                            <Typography variant="body1" className={classes.value}>{formatActivityTimestamp(new Date(metadata.cancelledAt))}</Typography>
                                        </div>
                                    )}
                                </CardContent>
                            </Card>
                        )}
                        {/* Order Metadata for OTC sends */}
                        {isOtcDetail && otcOrder?.metadata && Object.keys(otcOrder.metadata).length > 0 && (
                            <Card className={classes.infoCard}>
                                <CardContent className={classes.infoContent}>
                                    <Typography variant="overline" style={{fontSize: '0.75rem', fontWeight: 600, display: 'block', marginBottom: '8px'}}>
                                        Order Metadata
                                    </Typography>
                                    {Object.entries(otcOrder.metadata)
                                        .filter(([key, value]) => value != null && value !== '')
                                        .sort(([keyA], [keyB]) => {
                                            // Define preferred order
                                            const order = ['transactionDate'];
                                            const indexA = order.indexOf(keyA);
                                            const indexB = order.indexOf(keyB);
                                            if (indexA !== -1 && indexB !== -1) return indexA - indexB;
                                            if (indexA !== -1) return -1;
                                            if (indexB !== -1) return 1;
                                            return keyA.localeCompare(keyB);
                                        })
                                        .map(([key, value]) => {
                                            // Format the key for display
                                            const formatLabel = (str) => {
                                                const specialCases = {
                                                    'transactionDate': 'Transaction Date',
                                                    'payoutCurrency': 'Payout Currency',
                                                    'payoutAmount': 'Payout Amount',
                                                };
                                                if (specialCases[str]) return specialCases[str];
                                                return str.replace(/([A-Z])/g, ' $1').replace(/^./, (s) => s.toUpperCase()).trim();
                                            };
                                            
                                            // Format date/timestamp fields
                                            let displayValue = String(value);
                                            if (key.endsWith('At')) {
                                                // Full timestamp fields like 'completedAt'
                                                displayValue = formatActivityTimestamp(new Date(value));
                                            } else if (key.endsWith('Date') && value) {
                                                // Date-only fields like 'transactionDate' (YYYY-MM-DD)
                                                // Just display the date as-is without adding time
                                                displayValue = value;
                                            }
                                            
                                            return (
                                                <div key={key} className={classes.infoRow}>
                                                    <Typography variant="body1" className={classes.name}>{formatLabel(key)}</Typography>
                                                    <Typography variant="body1" className={classes.value}>{displayValue}</Typography>
                                                </div>
                                            );
                                        })}
                                </CardContent>
                            </Card>
                        )}
                        {/* Settlement Details for completed OTC sends */}
                        {isOtcDetail && status === "Completed" && otcOrder?.settlementDetails && (
                            <Card className={classes.infoCard}>
                                <CardContent className={classes.infoContent}>
                                    <Typography variant="overline" style={{fontSize: '0.75rem', fontWeight: 600, display: 'block', marginBottom: '8px'}}>
                                        Settlement Details
                                    </Typography>
                                    
                                    {Object.entries(otcOrder.settlementDetails)
                                        .filter(([key, value]) => value != null && value !== '')
                                        .map(([key, value]) => {
                                            // Format the key for display
                                            const formatLabel = (str) => {
                                                return str
                                                    .replace(/([A-Z])/g, ' $1')
                                                    .replace(/^./, (s) => s.toUpperCase())
                                                    .trim();
                                            };
                                            
                                            // Special handling for transaction URL
                                            if (key === 'transactionUrl') {
                                                return (
                                                    <div key={key} className={classes.buttonRow}>
                                                        <ActionButton
                                                            variant={'text'}
                                                            onClick={() => window.open(value, '_blank')}
                                                        >
                                                            View transaction
                                                        </ActionButton>
                                                    </div>
                                                );
                                            }
                                            
                                            return (
                                                <div key={key} className={classes.infoRow}>
                                                    <Typography variant="body1" className={classes.name}>
                                                        {formatLabel(key)}
                                                    </Typography>
                                                    <Typography variant="body1" className={classes.value}>
                                                        {typeof value === 'object' ? JSON.stringify(value) : String(value)}
                                                    </Typography>
                                                </div>
                                            );
                                        })}
                                </CardContent>
                            </Card>
                        )}
                        <OpsRole>
                            {isFiat && order && isPending &&
                                <>
                                    <div className={ classes.buttonContainer }>
                                        <ModalConsumer>
                                            { ({ showModal }) => (
                                                <ActionButton
                                                    onClick={ () => showModal(CompleteTransactionDialog, {
                                                        accountId,
                                                        onComplete: refreshActivityList,
                                                        orderId: id,
                                                        amount: amount,
                                                        currency: currency,
                                                        transactionType: TRANSACTION_TYPES.SEND_FIAT,
                                                        transactionCategory: TRANSACTION_CATEGORIES.ADJUSTMENT,
                                                        selectableCurrencies: ["USD"]
                                                    }) }
                                                    variant='primary'
                                                    size='lg'
                                                >
                                                    Complete
                                                </ActionButton>
                                            ) }
                                        </ModalConsumer>
                                    </div>
                                    { orderIsPending &&
                                    <div style={{ marginTop: "16px"}} className={ classes.buttonContainer }>
                                        <ModalConsumer>
                                            { ({ showModal }) => (
                                                <ActionButton
                                                    onClick={ () => showModal(ConfirmTransactionDialog, {
                                                        accountId,
                                                        onComplete: refreshActivityList,
                                                        orderId: id,
                                                        amount: amount,
                                                        currency: currency,
                                                        reference: displayReference,
                                                        label: "cancel",
                                                        transactionType: TRANSACTION_TYPES.CANCEL_SEND_FIAT,
                                                        transactionCategory: TRANSACTION_CATEGORIES.ADJUSTMENT,
                                                        selectableCurrencies: ["USD"]
                                                    }) }
                                                    variant='cancel'
                                                    size='lg'
                                                >
                                                    Cancel
                                                </ActionButton>
                                            ) }
                                        </ModalConsumer>
                                    </div>
                                    }
                                </>
                            }
                            {canRenderTronManualButtons &&
                                <div className={ classes.buttonContainer }>
                                    <ModalConsumer>
                                        { ({ showModal }) => (
                                            <ActionButton
                                                onClick={ () => showModal(CompleteTransactionDialog, {
                                                    accountId,
                                                    onComplete: refreshActivityList,
                                                    orderId: activityReference,
                                                    reference: manualSendReference,
                                                    amount: amount,
                                                    currency: currency,
                                                    transactionType: TRANSACTION_TYPES.COMPLETE_MANUAL_CRYPTO,
                                                    transactionCategory: TRANSACTION_CATEGORIES.ADJUSTMENT,
                                                    selectableCurrencies: [],
                                                    isCrypto: true
                                                }) }
                                                variant='primary'
                                                size='lg'
                                            >
                                                Complete
                                            </ActionButton>
                                        ) }
                                    </ModalConsumer>
                                </div>
                            }
                        </OpsRole>
                    </>
            }
        </div>
    )
}

const SendReceivedActivityDetails = ({
                                         customerId,
                                         activityId,
                                         type,
                                         resource,
                                         orderId,
                                         activityReference,
                                         isLoading,
                                         parentError,
                                         onClose,
                                         customer
                                     }) => {
    const history = useHistory();
    const [data, setData] = useState({})
    const [refresh, setRefresh] = useState(false)
    const [loading, setLoading] = useState(isLoading);
    const [error, setError] = useState(parentError);
    const dataProvider = useDataProvider();
    useEffect(() => {
        setRefresh(true)
    }, [])
    useEffect(() => {
        if (refresh === true) {
            setLoading(true)
            dataProvider.getOne(resource, { customerId, activityId, type, orderId })
                .then(({ data }) => {
                    setData(data);
                })
                .catch((error) => {
                    setError(error)
                })
                .finally(() => {
                    setLoading(false)
                    setRefresh(false)
                });
        }
    }, [refresh])
    const {
        categoryName,
        heading,
        status,
        senderName,
        sentAmount,
        tagline,
        transactionDate,
        transactionFee,
        blockchainNetwork,
        blockchainScanLink
    } = data
    const classes = useDetailStyles();
    return (
        <div className={ classes.root }>
            { (error || (!data && !loading)) ?
                <div className={ classes.errorContainer }>
                <GenericError onClick={() => setRefresh(true)} className={classes.error}/>
                </div>
                : loading ?
                    <div className={classes.resultContainer}>
                        <CircularLoader className={classes.loader} trigger={loading} loaderSize='125px'/>
                    </div>
                    :
                    <>
                        <Typography variant='button' className={classes.category}>
                            {categoryName}
                        </Typography>
                        <Typography variant='h2' className={classes.heading}>
                            {heading}
                        </Typography>
                        <Typography variant='h4' className={classes.heading}>
                            {tagline}
                        </Typography>
                        {customer && <Card className={classes.infoCard}>
                            <CardContent className={classes.infoContent}>
                                <div className={classes.infoRow}>
                                    <Typography variant="body1" className={classes.name}>Customer</Typography>
                                    <Typography variant="body1"
                                                onClick={() => {
                                                    history.push(`/customers/${customer.id}/show`);
                                                    onClose();
                                                }}
                                                className={`${classes.value} ${classes.linkValue}`}>{customer.name}</Typography>
                                </div>
                                <div className={classes.infoRow}>
                                    <Typography variant="body1" className={classes.name}>Customer ID</Typography>
                                    <Typography variant="body1" className={classes.value}>{customer.id}</Typography>
                                </div>
                            </CardContent>
                        </Card>}
                        <Card className={classes.infoCard}>
                            <CardContent className={classes.infoContent}>
                                <div className={classes.infoRow}>
                                    <Typography variant="body1" className={classes.name}>Created At</Typography>
                                    <Typography variant="body1"
                                                className={classes.value}>{`${formatActivityTimestamp(transactionDate)}`}</Typography>
                                </div>
                                {
                                    senderName &&
                                    <div className={classes.infoRow}>
                                        <Typography variant="body1" className={classes.name}>From</Typography>
                                        <Typography variant="body1"
                                                    className={classes.value}>{senderName}</Typography>
                                    </div>
                                }
                                {
                                    blockchainNetwork &&
                                    <div className={classes.infoRow}>
                                        <Typography variant="body1" className={classes.name}>Network</Typography>
                                        <Typography variant="body1"
                                                    className={classes.value}>{blockchainNetwork}</Typography>
                                    </div>
                                }
                                {
                                    activityReference &&
                                    <div className={classes.infoRow}>
                                        <Typography variant="body1" className={classes.name}>OrderID</Typography>
                                        <Typography variant="body1" className={classes.value}>{activityReference}</Typography>
                                    </div>
                                }
                                <Divider
                                    className={classes.divider}
                                    orientation="horizontal"
                                    variant="fullWidth"
                                />
                                {
                                    sentAmount &&
                                    <div className={classes.infoRow}>
                                        <Typography variant="body1"
                                                    className={classes.name}>Sent</Typography>
                                        <Typography variant="body1"
                                                    className={classes.value}>{sentAmount}</Typography>
                                    </div>
                                }
                                {
                                    transactionFee &&
                                    <div className={classes.infoRow}>
                                        <Typography variant="body1"
                                                    className={classes.name}>Transaction fee</Typography>
                                        <Typography variant="body1"
                                                    className={classes.value}>{transactionFee}</Typography>
                                    </div>
                                }
                                <div className={classes.infoRow}>
                                    <Typography variant="body1" className={classes.name}>Status</Typography>
                                    <Typography variant="body1" className={classes.value}>{status}</Typography>
                                </div>

                                {blockchainScanLink && <div className={classes.buttonRow}>
                                    <ActionButton
                                        variant={'text'}
                                        onClick={() => window.open(blockchainScanLink, '_blank')}
                                    >
                                        View in explorer
                                    </ActionButton>
                                </div>}
                            </CardContent>
                        </Card>
                    </>
            }
        </div>
    )
}

export default ViewActivityDrawer;
